import { StatisticalAnalysisDossiersExternalInfo } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { Nullable } from '@/shared/types/app.types'

export interface StatisticAnalysisExternalViewDetailTableState {
    externalInfo: Nullable<StatisticalAnalysisDossiersExternalInfo>
}
export const initialStatisticAnalysisExternalViewDetailTableState =
    (): StatisticAnalysisExternalViewDetailTableState => ({
        externalInfo: null
    })
